module.exports = __webpack_public_path__ + "static/media/Questions-1-10.bc2da126.png";